module.exports = __webpack_public_path__ + "d73065dbfe3a3574d57f9ae79c4eef95.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-bold.ttf
 ** module id = 17
 ** module chunks = 0
 **/